import {useDispatch, useSelector} from "react-redux";
import {financeSelector} from "../../../../../../redux/slices/financeSlice";
import {globalDataSelector, setIsInstallsEndingInfoPopupActive} from "../../../../../../redux/slices/globalDataSlice";
import {setSubscriptionEndingPopupActive, subscriptionSelector} from "../../../../../../redux/slices/subscriptionSlice";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import React, {useEffect} from "react";
import {convertDate} from "../../../../../../utils/helpers/formatTime";
import {setSubscriptionEndingLimit1, setSubscriptionEndingLimit3} from "../../../../../../storage/subscription";
import s from "../SubscriptionEndingInfoPopup/subscriptionEndingInfoPopup.module.scss";
import SvgSelector from "../../../../../../components/SvgSelector/SvgSelector";
import {subscriptionLimits} from "../../Subscriptions";
import {
    getInstallEndingIsNotifiedByInstallType,
    setInstallTypeIsNotified
} from "../../../../../../storage/installsLimits";

const InstallsEndingInfoPopup = () => {
    const {topUpBalanceIsActive} = useSelector(financeSelector);
    const {exitPopup, isCollapsedSidebar, isInstallsEndingInfoPopupActive} =
        useSelector(globalDataSelector);

    const {subscriptionsList, isSubscriptionEndingPopupActive} = useSelector(subscriptionSelector);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const {t} = useTranslation();

    useEffect(() => {
        if (exitPopup && !topUpBalanceIsActive) {
            // handleClosePopup();
        } else {
        }
    }, [exitPopup]);

    const activeSubscription = subscriptionsList.find(item => item?.is_active && item?.active_by_time)

    const {
        bgImage: subscriptionBgImage
    } = activeSubscription || {}

    const closePopup = () => {
        subscriptionLimits.forEach(({defaultKey}) => {

                const installType = defaultKey.split('_')[0]
                const installsCount = activeSubscription?.[defaultKey]

                if (installsCount <= 100 && getInstallEndingIsNotifiedByInstallType(installType) !== 'true') {
                    setInstallTypeIsNotified(installType)
                }
            }
        )

        dispatch(setIsInstallsEndingInfoPopupActive(false))
    }

    return (
        <div
            className={`${s.popupWrapper} ${isInstallsEndingInfoPopupActive ? s.active : ""} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
        >
            <div className={isInstallsEndingInfoPopupActive ? `${s.popup} ${s.active}` : s.popup}
            >
                <div className={s.header}
                     style={{backgroundImage: `url(${subscriptionBgImage})`}}
                >
                    <span className={s.iconWrapper}><SvgSelector id='subscriptions-icon'/></span>
                    <p className={s.title}>{t('info_about_subscription')}</p>
                </div>

                <div className={s.body}>
                    <p className={s.attentionTitle}>
                        {t('install_limit_warning')}
                    </p>
                    <ul className={s.installsDetails}>
                        {subscriptionLimits.map(({iconId, defaultKey}) => {
                            const installsCount = activeSubscription?.[defaultKey]

                            return (

                                <li
                                    key={iconId}
                                    className={`
                                    ${installsCount <= 100 && installsCount > 75 ? s.yellow : ''}
                                    ${installsCount <= 75 && installsCount > 50 ? s.orange : ''}
                                    ${installsCount <= 50 ? s.red : ''}
                                `}
                                >
                                    <SvgSelector id={iconId}/>
                                    <span>
                                                      {
                                                          installsCount ??
                                                          <SvgSelector id='all-in-icon'/>
                                                      }
                                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                </div>

                <div className={s.footer}>
                    <button
                        className={s.whiteBorderBtn}
                        onClick={closePopup}
                    >
                        {
                            t('continue')
                        }
                    </button>

                    <button
                        className={s.blueBorderBtn}
                        onClick={() => {
                            closePopup()
                            navigate('/subscriptions')
                        }}
                    >
                        {
                            t('subscriptions')
                        }
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InstallsEndingInfoPopup;